import { ProductStatus, OperationType, LinkedEntitlementRelationShipType } from '../../../../types';

export type OrderSummaryLineItem = {
  lineItemId: string;
  id: string;
  name: string;
  entitlementNumber: string;
  existingCloudSite?: string;
  estimateIncludingPartnerDiscount: number;
  discountPercent: number;
  totalDiscount: number;
  isAdminFeeApplicable: boolean;
  adminFee: number;
  itemLevelTaxInfo: any[];
  offeringName: string;
  billingCycleLabel: string;
  nextBillDate: string;
  productKey: string;
  appLineItems: OrderSummaryAppLineItem[];
  totalPriceOfApps: number;
  listPrice: number;
  grandTotal: number;
  estimatedNumberOfUsers: number;
  isItAJiraProduct: boolean;
  isFreeProduct: boolean;
  logoId: string | undefined;
  trialLengthInDays?: string;
  productStatuses?: ProductStatus[];
  startDate?: string;
  renewalOrEndDate?: string;
  otherLozengesOrStatuses?: string[];
  inTrial?: boolean;
  totalMarginAmount?: number;
  estimateIncludingPartnerMargin?: number;
  marginPercent?: number;
  lineItemType?: string;
  initialOfferingName?: string;
  isItAUpgrade?: boolean;
  isItADowngrade?: boolean;
  newPlanStartDate?: string;
  organisationId?: string | null | undefined;
  organisationName?: string | null | undefined;
  isSandbox?: boolean;
  isOnUpgradeTrial?: boolean;
  cancelReason?: string;
  relationshipType?: LinkedEntitlementRelationShipType;
  isOrgProduct?: boolean;
  parentEntitlementId?: string;
};

export type OrderSummaryLineItems = OrderSummaryLineItem[];

export type LineItemsActualEstimate = {
  totalExcludingDiscountAndTax: number;
  totalAmountToPay: number;
  totalTax: number;
  totalDiscountApplied: number;
  totalAdminFee?: number;
  totalPartnerDiscount?: number;
};

export type LineItemsRecurringEstimate = {
  totalExcludingDiscountAndTax: number;
  totalAmountToPay: number;
  totalTax: number;
  totalDiscountApplied: number;
  totalPartnerDiscount: number;
  totalOtherDiscount: number;
  totalAdminFee: number;
  totalListPrice: number;
};

export type OrderSummaryAppLineItem = {
  id: string;
  name: string;
  logoId: string;
  containerOrProductId: string;
  activeUsers: string;
  productId: string;
  pricingPlanId: string;
  offeringId: string;
  operationType: OperationType;
  trialLengthInDays?: string;
  promoCode?: string;
  grandTotal?: number;
  listPrice?: number;
  discountPercent?: number;
  totalDiscount?: number;
  total?: number | string;
  totalTax?: number | string;
  estimateIncludingPartnerDiscount?: number;
  allPromotionsApplied?: any[];
  isAdminFeeApplicable?: boolean;
  itemLevelTaxInfo?: Array<
    [
      string,
      {
        tax: number;
        taxPercent: number;
      }
    ]
  >;
  productStatuses?: ProductStatus[];
  inTrial?: boolean;
  isSandbox?: boolean;
  relationshipType?: LinkedEntitlementRelationShipType;
  cancelReason?: string;
  offeringName?: string;
};

export enum BillingProfileActionsEnum {
  CHANGE_BILLING_PROFILE = 'CHANGE_BILLING_PROFILE',
  CHANGE_PO_NUMBER = 'CHANGE_PO_NUMBER',
  NEW_BILLING_PROFILE = 'NEW_BILLING_PROFILE',
}
